import React from 'react'
import {LoadIndicator} from "devextreme-react";

const DevLoad = (props) => {
    return  <LoadIndicator  {...props}> {props.children} </LoadIndicator>;
    }
    
    export default DevLoad;